import React from 'react';
import { useSelector } from 'react-redux';

import { Navigate, Outlet, useLocation } from 'react-router-dom';
import {
  AGENCY_HOME,
  CHATTER_HOME,
  COLLECTIONS,
  FORBIDDEN,
  HOME,
  MESSAGES,
  UPDATE_PASSWORD,
  VAULT,
} from '../App/routes';
import { selectUser } from '../../store/slices/user/slice';
import { CRM_ORGANIZATION_MEMBER_ROLES, USER_ROLE } from '../../utils/constants';

const PrivateOutlet = ({ roles }) => {
  const user = useSelector(selectUser);
  const { pathname } = useLocation();

  if (!roles.includes(user.role)) {
    if (pathname === HOME) {
      if (user.role === USER_ROLE.INFLUENCER_REQUEST) {
        return <Navigate to={`/${UPDATE_PASSWORD}`} />;
      } else if (CRM_ORGANIZATION_MEMBER_ROLES.includes(user.role)) {
        return <Navigate to={`/${CHATTER_HOME}`} />;
      } else {
        return <Navigate to={`/${AGENCY_HOME}`} />;
      }
    }
    return <Navigate to={`/${FORBIDDEN}`} />;
  }

  if (user.role === USER_ROLE.INFLUENCER) {
    const ROUTES_FOR_MANUAL_CHATTING = [VAULT, MESSAGES, COLLECTIONS];
    if (!user.manualChatEnabled) {
      for (const route of ROUTES_FOR_MANUAL_CHATTING) {
        if (pathname.includes(route)) {
          return <Navigate to={`/${FORBIDDEN}`} />;
        }
      }
    }
  }

  return <Outlet />;
};

export default PrivateOutlet;
